module.exports = __webpack_public_path__ + "static/media/cv.f8312651.pdf";